import withResponsiveHOC from "/components/enhancements/responsive-hoc/responsive-hoc-component";
import ProductCardsGridDekstopComponent from "./product-cards-grid-dekstop-component.js";
import ProductCardsGridMobileComponent from "./product-cards-grid-mobile-component.js";
import DefaultProps from "./default-props";

const ProductCardsGridComponent = withResponsiveHOC(ProductCardsGridDekstopComponent, ProductCardsGridMobileComponent);
ProductCardsGridComponent.defaultProps = DefaultProps;

export default ProductCardsGridComponent;
